var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _radialGradient, _path5, _radialGradient2, _path6, _path7, _path8, _path9, _linearGradient4, _path0, _linearGradient5, _rect, _linearGradient6, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Defaulttrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UGlgmT9Yg7fNX9O1uiaHza",
    x1: 20.766,
    x2: 25.05,
    y1: 30.008,
    y2: 44.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0370c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#036fc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#036abd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0362b0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UGlgmT9Yg7fNX9O1uiaHza)",
    d: "M24,30.571c-8.837,0-16,4.921-16,10.286V42c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2 v-1.143C40,35.492,32.837,30.571,24,30.571z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6a121",
    d: "M29,32c0,1.897-2,4-5,4s-5-2.103-5-4c0-2.637,0-7.035,0-7.035h10C29,24.965,29,29.363,29,32z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UGlgmT9Yg7fNX9O1uiaHzb",
    x1: 32.917,
    x2: 34.251,
    y1: 20,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UGlgmT9Yg7fNX9O1uiaHzb)",
    d: "M32.916,18h-0.527v4h0.703c0.515,0,0.954-0.312,1.041-0.74l0.344-1.703 C34.642,18.743,33.897,18,32.916,18z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UGlgmT9Yg7fNX9O1uiaHzc",
    x1: -479.083,
    x2: -477.749,
    y1: 20,
    y2: 20,
    gradientTransform: "matrix(-1 0 0 1 -464 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UGlgmT9Yg7fNX9O1uiaHzc)",
    d: "M15.084,18h0.527v4h-0.703c-0.515,0-0.954-0.312-1.041-0.74l-0.344-1.703 C13.358,18.743,14.103,18,15.084,18z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "UGlgmT9Yg7fNX9O1uiaHzd",
    cx: 14.87,
    cy: -9.669,
    r: 12.224,
    gradientTransform: "translate(10.89 27.224) scale(.8816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UGlgmT9Yg7fNX9O1uiaHzd)",
    d: "M24,6.4c-4.441,0-9,0.675-9,10.275c0,0.768,0,5.877,0,6.698C15,26.8,20.4,31,24,31 s9-4.2,9-7.627c0-0.821,0-5.929,0-6.698C33,7.075,28.441,6.4,24,6.4z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "UGlgmT9Yg7fNX9O1uiaHze",
    cx: 5.168,
    cy: -14.298,
    r: 25.269,
    gradientTransform: "translate(10.89 27.224) scale(.8816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UGlgmT9Yg7fNX9O1uiaHze)",
    d: "M14,14c0,1.654,0.265,3.876,1,8l2-8h14c0,0,2,6.968,2,8c0.601-3.01,1-6.555,1-8H14z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff832b",
    d: "M35.5,18h-23c-0.276,0-0.5-0.224-0.5-0.5v-1c0-0.276,0.224-0.5,0.5-0.5h23c0.276,0,0.5,0.224,0.5,0.5 v1C36,17.776,35.776,18,35.5,18z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6900",
    d: "M34,15v-1c0-4.971-4.029-9-9-9h-2c-4.971,0-9,4.029-9,9v1c0,0.552-0.448,1-1,1h22 C34.448,16,34,15.552,34,15z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc720f",
    d: "M23,4h2c0.552,0,1,0.448,1,1v11h-4V5C22,4.448,22.448,4,23,4z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UGlgmT9Yg7fNX9O1uiaHzf",
    x1: 22.551,
    x2: 24.865,
    y1: 30.369,
    y2: 43.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fede00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd000"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UGlgmT9Yg7fNX9O1uiaHzf)",
    d: "M31,31.674V40H17v-8.326c-1.475,0.483-2.822,1.106-4,1.841V44h22V33.515 C33.822,32.78,32.475,32.157,31,31.674z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UGlgmT9Yg7fNX9O1uiaHzg",
    x1: 14.553,
    x2: 15.401,
    y1: 36.985,
    y2: 39.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b3b3b"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 3,
    x: 13,
    y: 37,
    fill: "url(#UGlgmT9Yg7fNX9O1uiaHzg)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UGlgmT9Yg7fNX9O1uiaHzh",
    x1: 32.553,
    x2: 33.401,
    y1: 36.985,
    y2: 39.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b3b3b"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 3,
    x: 31,
    y: 37,
    fill: "url(#UGlgmT9Yg7fNX9O1uiaHzh)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Defaulttrade);
export default __webpack_public_path__ + "static/media/icons8-defaulttrade.f77322f88dcea73092b3607f463f4298.svg";
export { ForwardRef as ReactComponent };